var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSync = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M10.569 3.126c1.52 0 2.958.496 4.148 1.4l-2.753 2.592 7.002.75-.329-7.034-2.792 2.63a8.34 8.34 0 0 0-5.276-1.866c-4.633 0-8.403 3.77-8.403 8.403h1.528a6.88 6.88 0 0 1 6.875-6.875M10.57 16.875a6.82 6.82 0 0 1-4.149-1.4l2.753-2.592-7.002-.751.33 7.035 2.791-2.63a8.34 8.34 0 0 0 5.276 1.866c4.633 0 8.403-3.77 8.403-8.403h-1.528a6.88 6.88 0 0 1-6.875 6.875"
})));
export default SvgSync;